import { EventEmitter, Injectable } from '@angular/core';
import { CartItemsService } from '../../shared/services/cart-items.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class CartRowsUpdaterService {
    private indexingSource: EventEmitter<null> = new EventEmitter();
    private indexedSource: EventEmitter<Array<any>> = new EventEmitter();
    public items: Array<Object> = [];
    public indexing$ = this.indexingSource.asObservable();
    public indexed$ = this.indexedSource.asObservable();

    constructor(
        protected router: Router,
        protected cartItemsService: CartItemsService
    ) {}

    /**
     * This call API to update items property value and components.
     **/
    public refresh(): Observable<any> {
        return new Observable(observable => {
            this.indexingSource.next();
            this.cartItemsService.index().subscribe((res: Response) => {
                this.setItems(res.json().data);
                this.indexedSource.next(this.items);
                observable.next(this.items);
            }, (err: Response) => {
                observable.error(err.json());
            });
        });
    }

    /**
     * This set items property value and update components.
     **/
    public setItems(items: Array<Object>) {
        this.items = items;
    }
    /**
     * This returns true if items property is empty.
     **/
    public isEmpty(): boolean {
        return this.items.length === 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/cart/services/cart-rows-updater.service.ts